import type { AppEntry } from "../types";
import { AppCard } from "./AppCard";

interface Props {
  apps: AppEntry[];
}

export function Gallery({ apps }: Props) {
  return (
    <div
      role="list"
      className="grid gap-2"
      style={{
        gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))",
        gridAutoRows: "1fr",
      }}
    >
      {apps.map(app => (
        <div role="listitem" key={app.id} className="h-full">
          <AppCard app={app} />
        </div>
      ))}
    </div>
  );
}
